import { combineReducers } from '@ngrx/store';

import { globalUiResultsReducer as results } from '@app/store/reducers/globalUi/results';
import { errorHandleReducer as errorHandle } from '@app/store/reducers/globalUi/error-handle.reducer';
import { navigationReducer as navigation } from '@app/store/reducers/globalUi/navigation.reducer';

export const globalUiReducer = combineReducers({
  errorHandle,
  results,
  navigation,
});
